// extracted by mini-css-extract-plugin
export default {"root":"container-module--root--ACgVt"};